/**
 * Staff roles allowed to open Clarity One via impersonation (support / testing).
 * - admin — Admin
 * - finance — Management
 * - sales — Sales Manager (PIC / sales leadership)
 */
export const CLARITY_ONE_STAFF_IMPERSONATION_ROLES = ["admin", "finance", "sales"] as const;

export type ClarityOneStaffImpersonationRole = (typeof CLARITY_ONE_STAFF_IMPERSONATION_ROLES)[number];

export function canStaffImpersonateClarityOneCustomer(role: string | undefined | null): boolean {
  if (!role) return false;
  return (CLARITY_ONE_STAFF_IMPERSONATION_ROLES as readonly string[]).includes(role);
}
